import React from "react";

function Specs() {
  const specs = [
    {
      group: "PREAMPLIFIER (MEASURED AT XLR OUTPUT)",
      specs: [
        {
          spec: "Maximum Output (<0.01% THD)",
          value: "10.7 VRMS, Subwoofer 11 VRMS",
        },
        {
          spec: "Frequency Response",
          value: "20 Hz — 35 kHz (+/-0.2dB)	",
        },
        {
          spec: "Frequency Response, Analog-Direct",
          value: "20 Hz — 80 kHz (+0, -2 dB)	",
        },
        {
          spec: "THD+N (4 Vrms output)",
          value: "-102 dB	",
        },
        {
          spec: "S/N Ratio (4 Vrms output, IEC-A filter)",
          value: "115 dB		",
        },
        {
          spec: "XLR Configuration",
          value: "Pin 1: Ground, Pin 2: Positive, Pin 3: Negative	",
        },
      ],
    },
    {
      group: "POWER CONSUMPTION",
      specs: [
        {
          spec: "Typical Load",
          value: "60 W",
        },
        {
          spec: "Standby",
          value: "0.3 W",
        },
        {
          spec: "Standby IP Control Enabled",
          value: "1.8 W",
        },
        {
          spec: "Standby HDMI Bypass Enabled",
          value: "4.9 W",
        },
      ],
    },
    {
      group: "DIMENSIONS",
      specs: [
        {
          spec: "Height (without feet)",
          value: '6" (15.24 cm)',
        },
        {
          spec: "Height with Rackmount Kit",
          value: "4U",
        },
        {
          spec: "Width",
          value: '17" (43.18 cm)',
        },
        {
          spec: "Depth (including wifi ant not power cord)",
          value: '14-1/2" (36.4 cm)	',
        },
        {
          spec: "Weight",
          value: "22.1 lbs, 10.1 Kg	",
        },
      ],
    },
    {
      group: "POWER REQUIREMENT",
      specs: [
        {
          spec: "120 V version",
          value:
            "In countries where the line voltage is 120 V, this product operates from a single phase AC power source that supplies between 108 V and 132 V at a frequency of 60 Hz.	",
        },
        {
          spec: "220-240 V version",
          value:
            "In countries where the line voltage is 220, 230, or 240 V, this product operates from a single phase AC power source that supplies between 198 V and 264 V at a frequency of 50 Hz.	",
        },
      ],
    },
  ];
  return (
    <div className="px-4 pt-5 pb-5 sm:px-0 sm:pt-0">
      <dl className="space-y-8 px-4 sm:px-6 sm:space-y-6">
        <ul className="">
          {specs.map((spec) => (
            <li className="py-5 ">
              <p className="font-bold text-sm lg:text-md text-gray-900 border-b-2 border-x-gray-700 mb-3">
                {spec.group}
              </p>
              <ul>
                {spec.specs?.map((s) => (
                  <li className="hover:bg-gray-100 mb-2">
                    <p className="font-medium text-sm lg:text-md text-gray-700 ">
                      {s.spec}
                    </p>
                    <p className="font-light text-sm lg:text-md text-gray-500 ">
                      {s.value}
                    </p>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </dl>
    </div>
  );
}

export default Specs;
